import { Integration } from '@/types';

/**
 * Integration categories for organizing integrations in the UI
 * Maps to directory structure in definitions/
 */
export enum IntegrationCategory {
  ApplicationSecurityPosture = 'Application Security Posture Management',
  ApplicationSecurityTesting = 'Application Security Testing',
  BreachAttackSimulation = 'Breach Attack Simulation',
  BugBounty = 'Bug Bounty',
  CloudSecurityPosture = 'Cloud Security Posture Management',
  CloudServiceProviders = 'Cloud Service Providers',
  ContentDeliverySolutions = 'Content Delivery Solutions',
  CyberAssetAttackSurface = 'Cyber Asset Attack Surface Management',
  Firewall = 'Firewall',
  ITServiceManagement = 'IT Service Management',
  IdentityAccessManagement = 'Identity & Access Management',
  ManagedDetectionResponse = 'Managed Detection and Response',
  ManagedDNSProviders = 'Managed DNS Providers',
  PassiveDNSProviders = 'Passive DNS Providers',
  SecurityRatings = 'Security Ratings',
  SourceCodeManagers = 'Source Code Managers',
  SaaSSecurity = 'SaaS Security',
  SecureCodeScanning = 'Secure Code Scanning',
  SIEM = 'Security Information and Event Management (SIEM)',
  ThreatIntelligence = 'Threat Intelligence',
  VulnerabilityManagement = 'Vulnerability Management',
  WebApplicationHosting = 'Web Application Hosting',
  WorkplaceMessaging = 'Workplace Messaging',
}

/**
 * Mapping of categories to their integration IDs
 * Used by registry for category-based lookups
 */
export type CategoryMapping = {
  [K in IntegrationCategory]: Integration[];
};

/**
 * Type for category statistics
 */
export interface CategoryStats {
  category: IntegrationCategory;
  count: number;
  integrations: Integration[];
}
